/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'

import { trackEvent } from 'utils/googleAnalytics'

import OPLogo from '../Images/OPLogo'
import MarkdownText from '../MarkdownText'
import { DashboardItemProps } from '../types'
import { DealsTargetBarContainer } from './DealsTargetBar.styled'

const PROGRESS_BAR_STEP_SIZE = 37
const BADGE_SIZE = 50
const MIN_BAR_SIZE = 15

function DealsTargetBar({
    componentStyle,
    data,
    dealershipName,
}: DashboardItemProps) {
    const [interaction, setInteraction] = useState(false)

    useEffect(() => {
        if (data) {
            const barSize = data.current * PROGRESS_BAR_STEP_SIZE

            window.document.documentElement.style.setProperty(
                '--deals-target-bar-width',
                `${barSize > 0 ? barSize : MIN_BAR_SIZE}px`,
            )
        }
    }, [data])

    function trackInteraction() {
        if (interaction) return

        trackEvent(
            'Loyalty Dashboard',
            'Progress Bar Interaction',
            'dealership',
            dealershipName,
        )

        setInteraction(true)
    }

    return (
        <DealsTargetBarContainer
            componentStyle={componentStyle}
            onMouseEnter={trackInteraction}
            data-testid="deals-target-bar-container"
        >
            <label>
                <MarkdownText text={data.title} />
            </label>
            <div className="container">
                <div className="bar">
                    <div className="progress" />
                    {data.checkpoints.map((checkpoint: any, index: number) => (
                        <figure
                            data-checkpoint={checkpoint.value}
                            className={`${checkpoint.leagueBadge} ${
                                data.current >= checkpoint.value
                                    ? 'achieved'
                                    : ''
                            }`}
                            style={{
                                animationDelay: `${checkpoint.value * 100}ms`,
                                marginLeft: `${
                                    checkpoint.value * PROGRESS_BAR_STEP_SIZE -
                                    BADGE_SIZE / 2 -
                                    (index === 0 ? 8 : 0)
                                }px`,
                            }}
                            key={index}
                        >
                            <OPLogo />
                        </figure>
                    ))}
                </div>
            </div>
        </DealsTargetBarContainer>
    )
}

export default DealsTargetBar
